const enumData = {
  namespaced: true,
  mutations: {},
  state: {
    enumData: JSON.parse(localStorage.getItem('enumData')),
  },
}

export default enumData
